import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import AdminLayout from "../layout/AdminLayout.vue";
import Dashboard from "../views/Dashboard.vue";
import HomeContent from "../views/HomeContent.vue";
import RoutesManage from "../views/RoutesManage.vue";
import RoutePlansManage from "../views/RoutePlansManage.vue";
import InspirationItemsManage from "../views/InspirationItemsManage.vue";
import ScenicSpotsManage from "../views/ScenicSpotsManage.vue";
import ScenicMapPointsManage from "../views/ScenicMapPointsManage.vue";
import HotelsManage from "../views/HotelsManage.vue";
import FoodsManage from "../views/FoodsManage.vue";
import CultureExperiencesManage from "../views/CultureExperiencesManage.vue";
import BasicServiceManage from "../views/BasicServiceManage.vue";
import CustomServiceManage from "../views/CustomServiceManage.vue";
import ServiceNeedOptionsManage from "../views/ServiceNeedOptionsManage.vue";
import ConsultationsManage from "../views/ConsultationsManage.vue";
import CustomDemandsManage from "../views/CustomDemandsManage.vue";
import ServiceOrdersManage from "../views/ServiceOrdersManage.vue";
import PaymentsManage from "../views/PaymentsManage.vue";
import ReviewsManage from "../views/ReviewsManage.vue";
import UsersManage from "../views/UsersManage.vue";
import StaffManage from "../views/StaffManage.vue";
import SettingsManage from "../views/SettingsManage.vue";
import AgreementVersionsManage from "../views/AgreementVersionsManage.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { public: true, title: "登录" }
    },
    {
      path: "/",
      component: AdminLayout,
      redirect: "/dashboard",
      children: [
        { path: "dashboard", name: "dashboard", component: Dashboard, meta: { title: "工作台总览" } },
        { path: "content/home", name: "home-content", component: HomeContent, meta: { title: "首页主视觉" } },
        { path: "content/routes", name: "routes-manage", component: RoutesManage, meta: { title: "线路管理" } },
        { path: "content/route-plans", name: "route-plans-manage", component: RoutePlansManage, meta: { title: "方案模板管理" } },
        { path: "inspirations", name: "inspirations-manage", component: InspirationItemsManage, meta: { title: "灵感探索管理" } },
        { path: "content/scenic-spots", name: "scenic-spots-manage", component: ScenicSpotsManage, meta: { title: "景点管理" } },
        { path: "content/scenic-map", name: "scenic-map-points-manage", component: ScenicMapPointsManage, meta: { title: "地图点位" } },
        { path: "content/hotels", name: "hotels-manage", component: HotelsManage, meta: { title: "酒店管理" } },
        { path: "content/foods", name: "foods-manage", component: FoodsManage, meta: { title: "美食推荐" } },
        { path: "content/culture", name: "culture-experiences-manage", component: CultureExperiencesManage, meta: { title: "文化体验" } },
        { path: "content/basic-service", name: "basic-service-manage", component: BasicServiceManage, meta: { title: "基础服务管理" } },
        { path: "content/custom-service", name: "custom-service-manage", component: CustomServiceManage, meta: { title: "高端定制管理" } },
        { path: "content/service-options", name: "service-need-options-manage", component: ServiceNeedOptionsManage, meta: { title: "服务选项" } },
        { path: "business/consultations", name: "consultations-manage", component: ConsultationsManage, meta: { title: "咨询管理" } },
        { path: "business/custom-demands", name: "custom-demands-manage", component: CustomDemandsManage, meta: { title: "定制需求" } },
        { path: "business/service-orders", name: "service-orders-manage", component: ServiceOrdersManage, meta: { title: "服务订单" } },
        { path: "business/payments", name: "payments-manage", component: PaymentsManage, meta: { title: "支付记录" } },
        { path: "business/reviews", name: "reviews-manage", component: ReviewsManage, meta: { title: "评价审核" } },
        { path: "customers/users", name: "users-manage", component: UsersManage, meta: { title: "小程序用户" } },
        { path: "team/staff", name: "staff-manage", component: StaffManage, meta: { title: "员工顾问" } },
        { path: "system/settings", name: "settings-manage", component: SettingsManage, meta: { title: "系统参数" } },
        { path: "system/agreements", name: "agreement-versions-manage", component: AgreementVersionsManage, meta: { title: "协议版本管理" } },
        { path: "manage/home", redirect: "/content/home" },
        { path: "manage/routes", redirect: "/content/routes" },
        { path: "manage/routePlans", redirect: "/content/route-plans" },
        { path: "manage/scenic", redirect: "/content/scenic-spots" },
        { path: "manage/scenicMap", redirect: "/content/scenic-map" },
        { path: "manage/hotels", redirect: "/content/hotels" },
        { path: "manage/foods", redirect: "/content/foods" },
        { path: "manage/culture", redirect: "/content/culture" },
        { path: "manage/services", redirect: "/content/basic-service" },
        { path: "manage/onlineConsults", redirect: "/business/consultations" },
        { path: "manage/customDemands", redirect: "/business/custom-demands" },
        { path: "manage/routeDemands", redirect: "/business/custom-demands" },
        { path: "manage/serviceOrders", redirect: "/business/service-orders" },
        { path: "manage/payments", redirect: "/business/payments" },
        { path: "manage/reviews", redirect: "/business/reviews" },
        { path: "manage/users", redirect: "/customers/users" },
        { path: "manage/recommenders", redirect: "/customers/users" },
        { path: "manage/staff", redirect: "/team/staff" },
        { path: "manage/settings", redirect: "/system/settings" }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem("admin_token");
  if (to.meta.public) {
    next();
    return;
  }
  if (!token) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }
  next();
});

export default router;
